<div class="modal-wrapper">
  @if (profileDetail$ | async; as profile) {
    <div class="modal-header">
      <h4 class="modal-title">
        {{profile.biodata.displayName}}
      </h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <div class="col-md-12 col-sm-12 col-lg-12 profile-header">
        <div class="row">
          <div class="col-md-4 col-sm-4 col-lg-4">
            <img #profileImg
              class="user-avatar user-avatar-xl text-center"
              src="{{profile.biodata.photoUrl}}"
              alt="{{profile.biodata.displayName}}"
              (error)="profileImg.src = profile.biodata.failedPhotoUrl">
            </div>
            <div class="col-md-8 col-sm-8 col-lg-8">
              <h5 class="card-title">
                @if (profile.employeeData.FacultyTitle) {
                  {{profile.employeeData.FacultyTitle}}
                }
                @if (!profile.employeeData.FacultyTitle) {
                  {{profile.biodata.description}}
                }
              </h5>
              @if (profile.employeeData.AcademicArea) {
                <p class="card-subtitle">{{profile.employeeData.AcademicArea}}</p>
              }
              @if (profile.employeeData.Division && (profile.employeeData.AcademicArea != profile.employeeData.Division)) {
                <p class="card-subtitle">{{profile.employeeData.Division}}</p>
              }
              @if (profile.academic.concentrations && profile.academic.concentrations.length > 0) {
                <div>
                  @for (concentration of profile.academic.concentrations; track concentration) {
                    <div>
                      @if (concentration.Value.length > 0) {
                        <small class="text-muted">{{concentration.Name}}: {{concentration.Value}}</small>
                      }
                    </div>
                  }
                </div>
              }
              <div class="profile-detail-connect">
                @if (hasLinkedIn) {
                  <a href="{{linkedIn}}" aria-label="Go to LinkedIn" class="btn btn-icon btn-outline-primary" target="_blank">
                    <i class="fab fa-linkedin" title="LinkedIn"></i>
                  </a>
                  }&nbsp;
                  @if (hasPage) {
                    <a href="{{webpage}}" aria-label="Go to Bio Page" class="btn btn-icon btn-outline-primary" target="_blank">
                      <i class="fas fa-info-circle" title="Bio Page"></i>
                    </a>
                  }
                </div>
              </div>
              <!-- Warnings for unpublished profiles and ferpa -->
              @if (profile.showLock && !profile.employeeData.IsEmployee && ( profile.biodata.id!=profileService.profile.biodata.id )) {
                <div class="col-12">
                  <div class="alert alert-warning mt-1">
                    <h6 class="alert-heading">Unpublished Profile</h6>
                    You have been given permission to see profile entries that people have not explicitly published.
                    Please use caution when sharing any information displayed below.
                  </div>
                </div>
              }
              @if (profile.showFerpaWarning && profile.biodata.id == profileService.profile.biodata.id) {
                <div class="card-subtitle alert alert-warning mt-1">
                  <h6 class="alert-heading">Private Directory Information</h6>
                  You have elected to have all of your directory information made private. Only you can see this profile card. Other students will not see you listed in class rosters, my classmates,
                  or any other list of students. For more information visit the <a target="_blank" href="https://registrar.unc.edu/academic-services/uncferpa/">UNC Registrar</a>.
                </div>
              }
              @if (profile.showFerpaWarning && profile.biodata.id != profileService.profile.biodata.id) {
                <div class="card-subtitle alert alert-warning mt-1">
                  <h6 class="alert-heading">Private Directory Information</h6>
                  This student has elected to have all of their directory information made private. You have been given special permission to view this card.
                  Do not share any of the information in this profile card.
                </div>
              }
              @if (profile.showLock && profile.biodata.id == profileService.profile.biodata.id && !profile.showFerpaWarning) {
                <div class="card-subtitle alert alert-warning mt-1">
                  <h6 class="alert-heading">Unpublished Profile</h6>
                  Some or all of your profile is not published. Other students will not be able to view your profile information.
                </div>
              }
            </div>
          </div>
          <div>
            <ul class="nav nav-tabs" role="tablist">
              @if ((profile.profile && profile.profile.length > 0) || profile.employeeData) {
                <li class="nav-item">
                  <a class="nav-link active show" data-toggle="tab" href="#profile">Profile</a>
                </li>
              }
            </ul>
            <div class="tab-content">
              @if (((profile.profile.length > 0) || profile.employeeData.IsEmployee)) {
                <div class="tab-pane fade active show card" id="profile" role="tabpanel">
                  <div class="card-body">
                    @if (profile.profile.length > 0 ) {
                      @for (item of profile.profile; track item) {
                        @if (item.name != 'LinkedIn' && item.name != 'Bio page') {
                          <div class="profile-detail-item">
                            <div class="profile-detail-item-header">
                              @if (!item.isPublished && !profile.employeeData.IsEmployee && ( profile.biodata.id!=profileService.profile.biodata.id )) {
                                <i
                                class="fad fa-lock-alt pe-1"></i>
                              }
                              <strong>{{item.name}}</strong>
                            </div>
                            @if (item.type=='multi') {
                              <ul>
                                @for (displayValue of item.value; track displayValue) {
                                  <li>
                                    {{displayValue}}
                                  </li>
                                }
                              </ul>
                            }
                            @if (item.type!='multi') {
                              <span [innerHTML]="item.value | kfLinky">
                              </span>
                            }
                          </div>
                        }
                      }
                    }
                    @if (profile.employeeData.IsEmployee) {
                      <div class="profile-detail-item">
                        <div class="profile-detail-item-header"><strong>Location</strong> </div>
                        <ul class="list-unstyled">
                          <li>{{profile.employeeData.Office}}</li>
                        </ul>
                      </div>
                      <div class="profile-detail-item">
                        <div class="profile-detail-item-header"><strong>Phone</strong> </div>
                        <ul class="list-unstyled">
                          <li>{{profile.employeeData.Phone}}</li>
                        </ul>
                      </div>
                      @if (!!_person?.Email) {
                        <div class="profile-detail-item">
                          <div class="profile-detail-item-header"><strong>Email</strong> </div>
                          <ul class="list-unstyled">
                            <li><a href="mailto:{{_person?.Email}}">{{_person?.Email}}</a></li>
                          </ul>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="modal-body">
          <div class="widget-loading text-center">
            <i class="fas fa-circle-notch fa-spin"></i>
          </div>
        </div>
      }
    </div>
